export const hasSeenTour = 'has-seen-tour'